import { defineStore } from 'pinia';

import { createdCampaigns } from '../resources/js/api/crowdpacs.js';

export const useCampaignStore = defineStore('campaign', {
  state: () => {
    return {
      isCampaignSection: false,
      userHasCreatedCampaigns: false,
      userCampaignList: [],
      campaignsLoaded: false,
    };
  },
  getters: {
    mostRecentCampaign(state) {
      return state.userCampaignList[0] || null;
    },
    mostRecentCampaignDashboardUrl(state) {
      const campaign = state.userCampaignList[0];
      return campaign?.id ? `/user/campaigns/${campaign.id}/dashboard` : null;
    },
  },
  actions: {
    setIsCampaignSection(val) {
      this.isCampaignSection = val;
    },
    getCreatedCampaigns() {
      createdCampaigns()
        .then(res => {
          this.userHasCreatedCampaigns = res.crowdpacs_created;
        })
        .catch(error => {
          console.warn(error);
        });
    },
    async getUserCampaigns(force = false) {
      if (this.campaignsLoaded && !force) {
        return;
      }
      try {
        const res = await createdCampaigns({ list: true });
        this.userCampaignList = res.crowdpacs || [];
        this.userHasCreatedCampaigns = res.crowdpacs.length > 0;
        this.campaignsLoaded = true;
      } catch (error) {
        console.warn(error);
      }
    },
    resetCampaignsCache() {
      this.campaignsLoaded = false;
      this.userCampaignList = [];
    },
  },
});
